// store/useStore.ts
import { create } from "zustand";

interface AppState {
  value: string;
  setValue: (v: any) => void;
}

export const useStore = create<AppState>(set => ({
  value: "",
  setValue: v => set({ value: v })
}));
